export const createTicketMixin = {
    methods: {
        createTicketFromTask(task, shortDescription, description, user) {

            //Initialize ticket object
            let ticketObj = {
                installation: task.configurationItem.label,
                shortDescription,
                description,
                internalId: null, // I dont think we can control this field
                supplier: '20850366-FB70-4C52-86E0-0ABE6EC925E9', //Will be set in Pilotbi.js
                company: '587da8b31bfbe8109234cb36464bcbfa', //EFB NET Company ID
                serviceGroup: 'a07de8b31bfbe8109234cb36464bcb0e', //Fiber Service Group ID
                subcategory: '607de8b31bfbe8109234cb36464bcb41', //'Opgave' Subcategory ID
                contacts: task.contacts,
                state: '1', //New State
            };

            //Add signed in user to contacts
            ticketObj.contacts.push({
                name: user.Name,
                role: 'ticket opretter',
                phone: user.Phone,
                mobile: user.Mobile,
                email: user.Email,
            });

            return ticketObj;
        }
    }
}